import { render, staticRenderFns } from "./SoundsPanel.vue?vue&type=template&id=1e6a62db&"
import script from "./SoundsPanel.vue?vue&type=script&lang=js&"
export * from "./SoundsPanel.vue?vue&type=script&lang=js&"
import style0 from "./SoundsPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VSpacer,VSwitch})
